import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import StyledInput from "../components/styledInput/StyledInput";
import UseContext from "../hooks/useContext";
import useTitle from "../hooks/TitleManager";

/**
 * Paramètres au niveau organisation (shell identique aux autres pages paramètres).
 * Brancher ici les appels API / sections quand le back sera disponible.
 */
const SettingsOrganization = () => {
  useTitle({ title: "Paramètres - Organisation" });
  const { userData } = UseContext();
  const organizationName = userData?.bigCompanyName?.trim() || "";

  return (
    <PageContainer type={"organization_settings"}>
      <SettingsLayout>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1 pl-4">
            <h1 className="ft-xl font-semibold text-gray-900">
              Paramètres de l'organisation
            </h1>
            <StyledInput
              type="text"
              label="Nom de l'organisation"
              value={organizationName}
              disabled
              onChange={() => {}}
            />
          </div>
        </div>
      </SettingsLayout>
    </PageContainer>
  );
};

export default SettingsOrganization;
